<script setup>
  const handleError = () => clearError({ redirect: '/' })
</script>

<template>
  <div
    class="d-flex align-items-center justify-content-center vh-100"
    style="background-color: #222529"
  >
    <div class="text-center text-white">
      <p class="fs-3">
        <span class="text-danger">Oops!</span>
        Algo deu errado.
      </p>
      <p class="lead">A página que você está procurando não existe.</p>

      <NuxtLink
        class="btn btn-light my-3"
        @click="handleError"
      >
        Voltar para Home
      </NuxtLink>
    </div>
  </div>
</template>
